import {
  VideoCameraOutlined,
  UsergroupAddOutlined,
  VideoCameraAddOutlined,
  FileAddOutlined,
  FileSearchOutlined,
  ContainerOutlined,
  AuditOutlined,
  UserAddOutlined,
  FileTextOutlined,
  FileUnknownOutlined,
  FileDoneOutlined,
  TeamOutlined,
  ShareAltOutlined
} from '@ant-design/icons';
import { OPERATIONS } from 'constants';

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const talentDiscovery = {
  id: 'talent_discovery',
  title: 'Talent Discovery',
  type: 'group',
  children: [
    {
      id: 'requisitions',
      title: 'Requisitions',
      type: 'item',
      url: '/talent-discovery/requisitions',
      icon: ContainerOutlined,
      operations: [OPERATIONS.VIEW, OPERATIONS.EDIT, OPERATIONS.DELETE, OPERATIONS.SMALL_TEAMS]
    },
    {
      id: 'applicant_tracker',
      title: 'Manual Applicant Tracker',
      type: 'item',
      url: '/talent-discovery/applicant-tracker',
      icon: UserAddOutlined,
      operations: [OPERATIONS.VIEW, OPERATIONS.EDIT, OPERATIONS.DELETE, OPERATIONS.SMALL_TEAMS]
    },
    {
      id: 'requisition_applicant_tracker',
      title: 'Requisition Applicant Tracker',
      type: 'item',
      url: '/talent-discovery/req-applicant-tracker',
      icon: UsergroupAddOutlined,
      operations: [OPERATIONS.VIEW, OPERATIONS.EDIT, OPERATIONS.DELETE, OPERATIONS.SMALL_TEAMS]
    },
    {
      id: 'qualification_questions',
      title: 'Qualification Questions',
      type: 'item',
      url: '/talent-discovery/qualification-questions',
      icon: AuditOutlined,
      operations: [OPERATIONS.VIEW, OPERATIONS.EDIT, OPERATIONS.DELETE]
    },
    {
      id: 'video_questions',
      title: 'Video Questions',
      type: 'item',
      url: '/talent-discovery/video-questions',
      icon: VideoCameraAddOutlined,
      operations: [OPERATIONS.VIEW, OPERATIONS.EDIT, OPERATIONS.DELETE]
    },
    {
      id: 'resume_profiles',
      title: 'Resume Profiles',
      type: 'item',
      url: '/talent-discovery/resume-profiles',
      icon: FileAddOutlined,
      operations: [OPERATIONS.VIEW, OPERATIONS.EDIT, OPERATIONS.DELETE]
    },
    {
      id: 'typing_tests',
      title: 'Typing Tests',
      type: 'item',
      url: '/talent-discovery/typing-tests',
      icon: FileTextOutlined,
      operations: [OPERATIONS.VIEW, OPERATIONS.EDIT, OPERATIONS.DELETE]
    },
    {
      id: 'qualification_question_profiles',
      title: 'Qualification Question Profiles',
      type: 'item',
      url: '/talent-discovery/qualification-question-profiles',
      icon: FileUnknownOutlined,
      operations: [OPERATIONS.VIEW, OPERATIONS.EDIT, OPERATIONS.DELETE]
    },
    {
      id: 'video_question_profiles',
      title: 'Video Question Profiles',
      type: 'item',
      url: '/talent-discovery/video-question-profiles',
      icon: FileAddOutlined,
      operations: [OPERATIONS.VIEW, OPERATIONS.EDIT, OPERATIONS.DELETE]
    },
    {
      id: 'video_question_results',
      title: 'Video Question Results',
      type: 'item',
      url: '/talent-discovery/video-question-results',
      icon: VideoCameraOutlined,
      operations: [OPERATIONS.VIEW]
    },
    {
      id: 'resume_screen_results',
      title: 'Resume Screen Results',
      type: 'item',
      url: '/talent-discovery/resume-screen-results',
      icon: FileSearchOutlined,
      operations: [OPERATIONS.VIEW]
    },
    {
      id: 'typing_assessment_results',
      title: 'Typing Test Results',
      type: 'item',
      url: '/talent-discovery/typing-test-results',
      icon: FileDoneOutlined,
      operations: [OPERATIONS.VIEW]
    },
    {
      id: 'class_requests_tracker',
      title: 'Class Requests Tracker',
      type: 'item',
      url: '/talent-discovery/class-requests',
      icon: TeamOutlined,
      operations: [OPERATIONS.VIEW, OPERATIONS.EDIT, OPERATIONS.DELETE]
    },
    {
      id: 'referral_tracker',
      title: 'Referral Tracker',
      type: 'item',
      url: '/talent-discovery/referrals',
      icon: ShareAltOutlined,
      operations: [OPERATIONS.VIEW]
    }
  ]
};

export default talentDiscovery;
